module.exports = __webpack_public_path__ + "static/media/coffee-me-icon.235b19dd.png";